import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import http from '@/http-common-coingecko'
//import {Response} from '@/types'
import { useToast } from "vue-toastification"
const toast = useToast()
@Module({ namespaced: true, name: '' })
class Currencies extends VuexModule {
    public status!: string
    public data!: object
    public error!: object

  @Mutation
  public onCurrencies(): void {
    this.status = "fetching"
    this.error = {}
    this.data = {}
  }
  @Mutation
  public onCurrenciesSuccess (data: object): void {
    this.status = "success"
    this.error = {}
    this.data = data
  }
  @Mutation
  public onCurrenciesError (err: object): void {
    this.status = "error"
    this.error = err
  }
  @Action({rawError: true})
  public getCurrencies(config: object){
    return new Promise((resolve, reject) => {
      this.context.commit("onCurrencies")
      http
      .get('/coins/markets', {params: config})
      .then(response => {
        this.context.commit("onCurrenciesSuccess", response.data)
        resolve(response)
      })
      .catch(error => {
        this.context.commit("onCurrenciesError", error)
        toast.error("Ups! we have a problems.")
        reject(error)
      })
    })
  }
}
export default Currencies